import { requestBaseService } from './index'
import { GenerateQueryV2, GenerateQueryV3 } from '../../utils/query'

export const getLiveTrades = (payload, params) => {
  const queryParams = GenerateQueryV3(params.query)
  const queryString = GenerateQueryV2({ ...params, query: queryParams })

  return requestBaseService({
    url: `emitten/ex/v1/stock-picks/${payload}`,
    params: {
      ...params,
      query: queryParams,
    },
    method: 'GET',
  })
}

export const getLiveTradeDetails = (payload) => {
  return requestBaseService({
    url: `emitten/ex/v1/stock-picks/${payload.category}/${payload.id}`,
    method: 'GET',
  })
}

const LiveTrade = {
  getLiveTrades,
  getLiveTradeDetails,
}

export default LiveTrade
